/* istanbul ignore file */
export { default } from './NoVehiclesAvailableCard';
